export const GET_RACE_NUM = "GET_RACE_NUM";
export const SET_RACE_NUM = "SET_RACE_NUM";
